import { InjectionToken } from "@angular/core";
import type { ConfirmSignInOutput, ResetPasswordOutput } from "aws-amplify/auth";
import {
    confirmResetPassword,
    confirmSignIn,
    fetchAuthSession,
    resetPassword,
    signIn,
    SignInOutput,
    signOut
} from "aws-amplify/auth";

// aws-amplify/auth exports are ES module live bindings (getter descriptors) and cannot
// be spied on directly in tests. Wrapping them in an injection token lets us swap in
// jasmine spies via TestBed providers without touching the module namespace.
export interface AmplifyAuthFunctions {
    signIn: (params: { username: string; password: string }) => Promise<SignInOutput>;
    signOut: () => Promise<void>;
    fetchAuthSession: () => Promise<Awaited<ReturnType<typeof fetchAuthSession>>>;
    resetPassword: (params: { username: string }) => Promise<ResetPasswordOutput>;
    confirmResetPassword: (params: {
        username: string;
        confirmationCode: string;
        newPassword: string;
    }) => Promise<void>;
    confirmSignIn: (params: { challengeResponse: string }) => Promise<ConfirmSignInOutput>;
}

export const AMPLIFY_AUTH = new InjectionToken<AmplifyAuthFunctions>("AMPLIFY_AUTH", {
    providedIn: "root",
    factory: () => ({ signIn, signOut, fetchAuthSession, resetPassword, confirmResetPassword, confirmSignIn })
});
